import { useRoleRepository } from "@/shared/contexts/repository-context";
import { usePagination } from "@/shared/hooks";
import { useHasGlobalPermission } from "@/shared/hooks/use-has-permission";
import { getGetRoleListPaginatedQueryKey } from "@/spz-api/roles/roles";
import { useGetMeSuspense } from "@/spz-api/user/user";
import { GlobalPermission } from "@spz/shared-domain";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useUpsertRoleDialog } from "../dialogs/use-upsert-role-dialog";
import { useRolesColumns } from "../hooks/use-roles-columns";

export const selectRolesViewModel = () => {
  const { data: me } = useGetMeSuspense();
  const roleRepository = useRoleRepository();

  const hasRolesManagementPermission = useHasGlobalPermission(
    GlobalPermission.RolesManage,
    me,
  );
  const columns = useRolesColumns();
  const roleDialog = useUpsertRoleDialog();
  const {
    currentPage,
    pageSize,
    paginationParams,
    handlePageChange,
    handlePageSizeChange,
  } = usePagination();
  const [searchQuery, setSearchQuery] = useState("");

  const queryParams = {
    page: paginationParams.page,
    pageSize: paginationParams.pageSize,
    search: searchQuery,
  };

  const { data: roles = [], isLoading } = useQuery({
    queryKey: getGetRoleListPaginatedQueryKey(queryParams),
    queryFn: () => roleRepository.getRoles(queryParams),
  });

  return {
    columns,
    roles: {
      data: roles,
      total: roles.length,
    },
    isLoading,
    createRoleDialog: {
      open: () => roleDialog.open({}),
    },
    currentPage,
    pageSize,
    totalPages: roles.length > 0 ? Math.ceil(roles.length / pageSize) : 0,
    handlePageChange,
    handlePageSizeChange,
    setSearchQuery,
    hasRolesManagementPermission,
  };
};
